import './Points.css'
import { FC } from 'react'
import { Flex } from 'antd'
import { points } from '../../contents/points'
import { useResponxiveContext } from '../../context/responsive-context'

export const Points: FC = () => {
  const { useVertical } = useResponxiveContext()
  return (<>
    { !useVertical &&
    <Flex className="Points-container">
    <Flex className="Points-bullets-container" vertical justify={'space-evenly'} >
    <Flex className="Points-bullets-container" justify={'space-evenly'} style={{width: '100%'}}>
        <div className="Points-main-text">
        <Point number={0} content={points[0]} />
        </div>
        <div className="Points-main-text">
        <Point number={1} content={points[1]} />
        </div>
    </Flex>
    <Flex className="Points-bullets-container" justify={'space-evenly'} style={{width: '100%'}}>
        <div className="Points-main-text">
        <Point number={2} content={points[2]} />
        </div>
    </Flex>
    <Flex className="Points-bullets-container" justify={'space-evenly'} style={{width: '100%'}}>
        <div className="Points-main-text">
        <Point number={3} content={points[3]} />
        </div>
        <div className="Points-main-text">
        <Point number={4} content={points[4]} />
        </div>
    </Flex>
    </Flex>
    </Flex>
  }
  { useVertical &&
    <Flex className="Points-container">
    <Flex className="Points-bullets-container" vertical justify={'space-evenly'} align={'center'} >
    {points.map((p, i) => {
      return (
        <div key={i} className="Points-main-text-vertical">
          <Point number={i} content={p} />
        </div>
      )
    })}
    </Flex>
    </Flex>

  }
  </>)
}

const Point: FC<{number: number, content: string}> = ({number, content}) => {
  const { useVertical } = useResponxiveContext()
  return (
    <Flex className="Points-item">
      <div className={useVertical ? "Points-circle-vertical" : "Points-circle"}>
        <span className={useVertical ? "Points-number-vertical" : "Points-number"}>{number + 1}</span>
      </div>
      <div className={ useVertical ? "Points-content-vertical" : "Points-content"}>
        <p className="Points-text">{content}</p>
      </div>
    </Flex>
  )
}
